import getTranslations from './getTranslations';

export const actions = {
    getTranslations,
};

export default actions;
